import { makeStyles } from '@material-ui/styles';
import ScheduleModal from '../../components/ScheduleModal';
import { groupBy } from 'lodash';
import { utcToZonedTime, format } from 'date-fns-tz';

import { MainButton, Text } from '@bizzabo/design-system';
import { Activity } from '@bizzabo/entities';

export type OverlapSessionsModalData = {
    isOpen: boolean;
    overlapSessions: Activity[];
};

interface OverlapSessionsModalProps {
    overlapSessionsData: OverlapSessionsModalData;
    timeZone: string;
    closeModal: () => void;
}

const OverlapSessionsModal: React.FC<OverlapSessionsModalProps> = ({
    overlapSessionsData = {},
    timeZone,
    closeModal,
}) => {
    const classes = useStyles();
    const sessions = groupBy(overlapSessionsData.overlapSessions, 'startDateUTCTimestamp');

    return (
        <ScheduleModal
            isOpen={overlapSessionsData.isOpen}
            closeModal={closeModal}
            contentClassName={classes.contentOverlap}
        >
            <Text variant="t60" className={classes.titleModal}>
                Conflicted sessions
            </Text>
            <ul className={classes.timesList}>
                {Object.entries(sessions).map(([startTime, sessions]) => (
                    <li className={classes.timeItem} key={startTime}>
                        <Text variant="t71" className={classes.time}>
                            {format(utcToZonedTime(new Date(Number(startTime)), timeZone), 'p')}
                        </Text>
                        <ul className={classes.sessionsList}>
                            {sessions.map(session => (
                                <li className={classes.sessionItem} key={session.id}>
                                    <Text variant="t71">{session.title}</Text>
                                </li>
                            ))}
                        </ul>
                    </li>
                ))}
            </ul>
            <MainButton variant="fill" onClick={closeModal}>
                Close
            </MainButton>
        </ScheduleModal>
    );
};

const useStyles = makeStyles(
    theme => ({
        contentOverlap: {
            paddingLeft: 0,
            paddingRight: 0,
        },
        titleModal: {
            marginBottom: 24,
            textAlign: 'center',
        },
        timesList: {
            width: '100%',
            maxHeight: '200px',
            overflowY: 'auto',
            padding: '0 40px',
            margin: '0 0 25px',
            listStyle: 'none',
            [theme.breakpoints.up('sm')]: {
                maxHeight: '300px',
            },
        },
        timeItem: {
            display: 'flex',
            padding: '16px 0',
            borderBottom: 'solid 1px #DEDEDE',
            '&:last-child': {
                borderBottom: 'none',
            },
        },
        time: {
            minWidth: '20%',
            color: '#767676',
        },
        sessionsList: {
            flex: 1,
            padding: 0,
            margin: '0 0 0 15px',
            listStyle: 'none',
        },
        sessionItem: {
            padding: '16px 0',
            borderBottom: 'solid 1px #DEDEDE',
            '&:first-child': {
                paddingTop: 0,
            },
            '&:last-child': {
                paddingBottom: 0,
                borderBottom: 'none',
            },
        },
    }),
    { classNamePrefix: 'overlap-session-modal' }
);

export default OverlapSessionsModal;
